/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React from 'react';
import { bool, element, func, node, number, object, oneOf, oneOfType, shape, string, } from 'prop-types';
import Dropdown, { TRIGGER, PLACEMENT } from '../../atoms/dropdown';
import setClass from '../../common/set-class';
import { PopoverBlock, PopoverHeader } from './popover-parts';
function Popover({ trigger, placement, withArrow, classes, styles, children, popoverContent, renderPlace, offset, }) {
    const toRender = typeof popoverContent === 'function'
        ? popoverContent
        : (close) => React.cloneElement(popoverContent, { close });
    return (React.createElement(Dropdown, { style: styles?.root, className: classes?.root, withArrow: withArrow, dropdownClassName: setClass([classes?.dropdown, 'b-popover__body']), dropdownStyle: styles?.dropdown, trigger: trigger, placement: placement, renderPlace: renderPlace, offset: offset, fitTriggerWidth: false, render: toRender }, children));
}
Popover.propTypes = {
    trigger: oneOf([...Object.keys(TRIGGER)]),
    placement: oneOf([...Object.values(PLACEMENT)]),
    withArrow: bool,
    classes: shape({
        root: string,
        dropdown: string,
    }),
    styles: shape({
        root: object,
        dropdown: object,
    }),
    children: oneOfType([node, element]).isRequired,
    popoverContent: oneOfType([func, node, element]).isRequired,
    renderPlace: oneOfType([node, element, object]),
    offset: number,
};
Popover.defaultProps = {
    trigger: 'hover',
    placement: PLACEMENT.bottom,
    withArrow: true,
    classes: null,
    styles: null,
    renderPlace: null,
    offset: null,
};
Popover.Header = PopoverHeader;
Popover.Content = (props) => (React.createElement(PopoverBlock, { ...props, className: setClass(['b-popover__content-wrapper', props?.className]) }));
Popover.Block = (props) => (React.createElement(PopoverBlock, { ...props, className: setClass(['b-popover__content-block', props?.className]) }));
export default Popover;
